import React from 'react'
import { ReactComponent as Jeff } from './../images/jeff_404.svg'
import { Button } from '@demandlocal/components'
import { useNavigate } from 'react-router-dom'
import { match, P } from 'ts-pattern'
import CodeBlock from './CodeBlock'

const Error404 = ({
  error,
  resetErrorBoundary,
}: {
  error?: Error
  resetErrorBoundary?: () => void
}): JSX.Element => {
  const navigate = useNavigate()
  return (
    <div
      className={
        'flex flex-1 w-full h-full items-center justify-center text-primary-xiketic py-2'
      }>
      <div className={'flex flex-col items-center gap-12 text-primary-xiketic relative'}>
        <div
          className={
            'absolute text-[444px] font-bold text-transparent bg-clip-text bg-gradient-to-b from-[#E0F5FA] -translate-y-20 -translate-x-8'
          }>
          404
        </div>
        <Jeff className={'z-10'} />
        <div className={'flex flex-col gap-4 items-center'}>
          <h1 className={'font-bold text-5xl'}>You found Jeff!</h1>
          <h3 className={'font-medium text-2xl'}>He’s been lost from some time now.</h3>
          <h4 className={'font-medium text-2xl'}>
            If you feel lost too, maybe try refreshing to see if Jeff goes away!
          </h4>
        </div>
        <div className={'flex flex-col gap-4 items-center text-base font-medium'}>
          {match(resetErrorBoundary)
            .with(P.not(P.nullish), () => (
              <div className={'flex flex-col gap-4 max-w-3xl'}>
                <p className={'text-center'}>
                  You can help him find his way back by providing this code to your
                  account manager.
                </p>
                <CodeBlock code={error?.stack ? btoa(error?.stack) : undefined} />
              </div>
            ))
            .otherwise(() => (
              <p>You can go back or join Jeff in a Pina Colada competition, your call.</p>
            ))}
        </div>
        <div>
          {match(resetErrorBoundary)
            .with(P.not(P.nullish), () => (
              <Button onClick={resetErrorBoundary}>Try again</Button>
            ))
            .otherwise(() => (
              <Button
                onClick={() => {
                  navigate('/dashboard')
                }}>
                Go back
              </Button>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Error404
